module.exports = __webpack_public_path__ + "static/media/SE_Orddiktat.fef12b91.mp4";